import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../App';
import { useNavigate } from 'react-router-dom';
import { OnboardingContainer } from '../../common/components/OnboardingContainer';
import { OnboardingPc } from './components/pc/OnboardingPC';
import { appRoutes } from '../../AppRoutes';
import { UpdateWorkspace } from '../../shared/types/workspaceTypes';
import { OnboardingMobile } from './components/mobile/OnboardingMobile';
import { getSavedAuth } from '../../common/utils/storage';
import { getUser } from '../../common/api/apiClient';
import { doRedirect } from '../../common/utils/utils';

const initialState: UpdateWorkspace = {
  name: '',
  teams: [],
  parts: [],
  contact: {
    organization_name: '',
    officer_name: '',
    officer_contact: '',
  },
  location: {
    address: '',
    address_detail: '',
    parking: '',
    zoom_lv: 3,
    x: 126.970634,
    y: 37.5555005,
  },
  showCandidatePower: true,
  tree_signature: '',
};
export const CreateCompany: React.FC = () => {
  const { isMobile, redirect } = useContext(AppContext);
  const navigate = useNavigate();
  const [data, setData] = useState<UpdateWorkspace>({ ...initialState });
  const [step, setStep] = useState<number>(1);

  useEffect(() => {
    const auth = getSavedAuth();
    if (auth) {
      getUser(auth?.access_token).then(user => {
        if (user.companies.length) {
          doRedirect(redirect, auth);
        }
      });
    }
  }, []);

  return (
    <OnboardingContainer step={'create'} createStep={step}>
      {isMobile ? (
        <OnboardingMobile data={data} step={step} setStep={setStep} onChange={setData} />
      ) : (
        <OnboardingPc data={data} step={step} setStep={setStep} onChange={setData} onPrev={() => navigate(appRoutes.welcome.path())} />
      )}
    </OnboardingContainer>
  );
};
